import React, { useState, useEffect } from 'react'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { Footer } from '../../components/Footer/Footer'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { ErrorMessage } from '../../components/ErrorMessage/ErrorMessage'
import {
  Box,
  FormControlLabel,
  FormGroup,
  TextField,
  useMediaQuery
} from '@mui/material'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { appTheme } from '../../theme'
import Switch from '@mui/material/Switch'
import { flexItemCenter, flexrow, inputFiledStyle, root } from '../../global'
import { useStyles } from './style'
import { useNavigate, useParams } from 'react-router-dom'
import { updateAudience, eventDetail } from '../../services/EventService'
import { SendInvitation, Role } from '../../services/Types'
import { EventTitle } from '../../components/EventTitle/EventTitle'
import { PageTitle } from '../../components/PageTitle/PageTitle'
import AudienceIcon from '../../images/audienceIcon.svg'
import { RadioButton } from '../../components/RadioButton/RadioButton'
import moment from 'moment'
import { DistributionListSelector } from '../../components/DistributionListSelector/DistributionListSelector'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

var isWebView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, '96px', 8, '96px') }
    : { padding: theme.spacing(0, 4, 8, 4) }
)

export default function AudiencePage() {
  const classes = useStyles()
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))

  const [errorMessage, setErrorMessage] = useState('')
  const [invitationNotesError, setInvitationNotesError] = useState('')

  const [showServerError, setShowServerError] = useState(false)
  const [serverError, setServerError] = useState('')

  const [eventData, setEvent] = useState<any>({
    overHundredParticipants: true,
    sendInvitation: 'OWN',
    invitationDistributionList: '',
    invitationNotes: ''
  })
  let { id } = useParams()

  const [distributionList, setDistributionList] = useState<string[]>([])

  const getAudience = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDistributionList([])
    setEvent({ ...eventData, overHundredParticipants: event.target.checked })
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.value)
    setEvent({ ...eventData, sendInvitation: event.target.value })
  }
  const handleInvitationNotes = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEvent({ ...eventData, invitationNotes: event.target.value })
    if (event.target.value === SendInvitation.OWN) {
      setDistributionList([])
    }
    setInvitationNotesError(
      event.target.value.length >= 500 ? 'Character limit reached' : ''
    )
  }

  // useEffect(() => {
  //   if (!eventData.overHundredParticipants) {
  //     setDistributionList([])
  //   }
  // }, [eventData.overHundredParticipants])

  const navigate = useNavigate()
  const backClick = async () => {
    navigate('/event/staff/' + id)
  }

  const validateDistributionList = () => {
    if (eventData.sendInvitation !== 'OWN' && distributionList.length === 0) {
      setErrorMessage(
        'In order to proceed, you must select an option from the Distribution Lists below. '
      )
      return false
    } else {
      setErrorMessage('')
      return true
    }
  }

  useEffect(() => {
    showServerError &&
      setTimeout(() => {
        setShowServerError(false)
      }, 5000)
  }, [showServerError])

  const displayServerError = () => {
    setShowServerError(true)
    setServerError('Internal server error')
  }

  useEffect(() => {
    setEvent({
      ...eventData,
      invitationDistributionList: JSON.stringify(distributionList)
    })
  }, [distributionList]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        console.log(data)
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            if (data.eventDetail.data === null) {
              return navigate('/')
            }
            if (data.eventDetail.data.creater.id !== user.id && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            if (data.eventDetail.data.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            let liveRoomBooking = data.eventDetail.data.roomBooking?.find((x: any) => x.category === 'live')
            if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            setEvent({
              ...eventData,
              title: data.eventDetail.data.title,
              eventType: data.eventDetail.data.eventType,
              overHundredParticipants:
                data.eventDetail.data.overHundredParticipants,
              sendInvitation: data.eventDetail.data.sendInvitation,
              invitationNotes: data.eventDetail.data.invitationNotes,
              invitationDistributionList:
                data.eventDetail.data.invitationDistributionList
            })
            if (data.eventDetail.data.invitationDistributionList !== null) {
              setDistributionList(
                JSON.parse(data.eventDetail.data.invitationDistributionList)
              )
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (id !== undefined) {
      loadEventData()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const nextClick = async () => {
    if (validateDistributionList()) {
      try {
        const results = await updateAudience(
          Number(id),
          eventData.overHundredParticipants,
          eventData.sendInvitation,
          eventData.invitationDistributionList,
          eventData.invitationNotes
        )
        const { data } = results
        if (data) {
          if (data.updateAudience.statusCode === 200) {
            navigate('/event/dateAndTime/' + id)
          } else {
            displayServerError()
          }
        } else {
          displayServerError()
        }
      } catch (error) {
        displayServerError()
      }
    } else {
      // displayServerError()
      return
    }
  }

  const saveExit = async () => {
    try {
      const results = await updateAudience(
        Number(id),
        eventData.overHundredParticipants,
        eventData.sendInvitation,
        eventData.invitationDistributionList,
        eventData.invitationNotes
      )
      const { data } = results
      if (data) {
        if (data.updateAudience.statusCode === 200) {
          navigate('/')
        } else {
          displayServerError()
        }
      } else {
        displayServerError()
      }
    } catch (error) {
      displayServerError()
    }
  }

  return (
    <div className='App' style={root}>
      <ProgressBar
        activePageTitle='Audience'
        requestType={eventData.eventType}
      />

      <Item sx={{ bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <Box style={flexItemCenter}>
          <Grid sx={{ pb: 8, maxWidth: '1248px' }} container>
            {showServerError && (
              <Grid item xs={12} sm={12} md={12}>
                <ErrorMessage
                  message={serverError}
                  justifyContent='center'
                  icon={true}
                />
              </Grid>
            )}

            <EventTitle title={eventData.title} />

            <Grid
              lg={12}
              container
              sx={{
                backgroundColor: [
                  SendInvitation.ALL,
                  SendInvitation.NOTOWN
                ].includes(eventData.sendInvitation)
                  ? '#FFFFFF'
                  : '',
                borderRadius: '40px'
              }}
            >
              <Grid
                item
                sm={12}
                md={6}
                sx={{
                  bgcolor: '#ffffff',
                  borderRadius: '40px',
                  px: { lg: '32px', md: '24px', xs: '21px' },
                  py: { lg: '24px', md: '22px', xs: '21px' },
                  gap: '8px'
                }}
              >
                <Box sx={{ px: { sm: '20px' } }}>
                  <PageTitle title='Audience' iconPath={AudienceIcon} />
                </Box>

                <Alert severity='warning'>
                  <AlertTitle>Changing Audience Size</AlertTitle>
                  <Typography variant="body2">
                    Once your event is approved, revisions to the audience size may limit the features available. Event Support will follow-up to confirm what revisions can be accommodated once you re-submit.
                  </Typography>
                </Alert>

                <Grid item sm={12} md={12} sx={{ mt: '4px' }}>
                  <Box
                    className={classes.leftBlock}
                    sx={{
                      px: { lg: '20px', xs: '0' },
                      py: { lg: '16px', xs: 1 },
                      mb: { lg: '24px', xs: 2 }
                    }}
                  >
                    <FormGroup sx={{ mb: '16px' }}>
                      <FormControlLabel
                        control={
                          <Switch
                            onChange={getAudience}
                            checked={eventData.overHundredParticipants}
                            color='secondary'
                          />
                        }
                        label={
                          <Typography textAlign='left'>
                            We expect more than 300 participants for this event
                          </Typography>
                        }
                      />
                    </FormGroup>

                    <Box
                      sx={{
                        px: '16px',
                        py: '22px',
                        gap: '8px',
                        background: 'rgba(255, 245, 235, 1)',
                        borderRadius: '12px',
                        textAlign: 'left'
                      }}
                    >
                      <Typography display='inline' fontWeight='500'>
                        Note:
                      </Typography>
                      <Typography display='inline' noWrap>
                        &nbsp;
                      </Typography>
                      <Typography display='inline'>
                        Breakout rooms will only be available for events with
                        fewer than 300 participants.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Box className={classes.leftBlock}>
                  <Typography
                    align='left'
                    variant='subtitle1'
                    sx={{ mb: 2.5, fontWeight: '500', letterSpacing: '0.5px' }}
                  >
                    Do you have your own mailing list that you would like to
                    send the invitations to?
                    <Box sx={{ color: 'error.main', display: 'inline' }}>
                      {' '}
                      *
                    </Box>
                  </Typography>

                  <RadioButton
                    selected={eventData.sendInvitation}
                    handleChange={handleChange}
                    radioButtons={[
                      {
                        value: SendInvitation.OWN,
                        label:
                          'Yes - I have my own mailing list that I will be responsible for forwarding the invitation to.'
                      },
                      {
                        value: SendInvitation.ALL,
                        label:
                          'Yes - I have my own mailing list that I will email, but I also want the invitations to go through the distribution lists that I have selected.'
                      },
                      {
                        value: SendInvitation.NOTOWN,
                        label:
                          'No - I will select from the WorkforceGPS distribution lists.'
                      }
                    ]}
                  />

                  <Box
                    sx={{
                      mt: 3.5,
                      mr: { xs: 0, sm: 1 },
                      ml: { xs: 0, sm: -1 }
                    }}
                  >
                    <TextField
                      className={classes.textField}
                      style={inputFiledStyle}
                      sx={{
                        bgcolor: 'white',
                        '.MuiOutlinedInput-root.Mui-focused': {
                          fieldset: { borderColor: '#006BD7' }
                        }
                      }}
                      name='notes'
                      value={eventData.invitationNotes || ''}
                      onChange={handleInvitationNotes}
                      label={'Audience & Invitation Requests'}
                      multiline
                      rows={3}
                      placeholder='Use this field to share audience or invitation requests and/or list the name and email for an additional point of contact who should be copied on all event logistics communications.'
                      fullWidth
                      inputProps={{ maxLength: 500 }}
                      InputLabelProps={{ shrink: true }}
                      error={!!invitationNotesError}
                    />
                    <Box sx={{ display: 'flex' }}>
                      <Typography
                        sx={{
                          color: '#D50000',
                          flex: 1,
                          fontSize: 12,
                          ml: 3,
                          textAlign: 'left'
                        }}
                      >
                        {invitationNotesError}
                      </Typography>
                      <Typography
                        sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 12 }}
                      >
                        {eventData.invitationNotes?.length || 0} / 500
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                sx={{
                  mt: { lg: '30px' },
                  px: { lg: '32px', md: '24px', sm: '21px' },
                  py: { lg: '24px', md: '22px', sm: '21px' },
                  gap: '8px'
                }}
              >
                {(eventData.sendInvitation === SendInvitation.ALL ||
                  eventData.sendInvitation === SendInvitation.NOTOWN) && (
                  <Box
                    sx={{ bgcolor: 'transparent' }}
                    className={classes.rightBlock}
                  >
                    <Typography
                      align='left'
                      variant='subtitle1'
                      sx={{ fontWeight: 500, ml: { xs: '14px' } }}
                    >
                      WorkforceGPS Distribution Lists:
                      <Box sx={{ color: 'error.main', display: 'inline' }}>
                        {' '}
                        *
                      </Box>
                    </Typography>
                    {errorMessage !== '' ? (
                      <Typography
                        color='error.main'
                        align='left'
                        sx={{
                          fontSize: 12,
                          fontWeight: 400,
                          ml: { xs: '14px' }
                        }}
                      >
                        {errorMessage}
                      </Typography>
                    ) : (
                      <Box className={classes.errorBox}></Box>
                    )}

                    <Box sx={{ mb: 1 }} className={classes.checkboxGroup}>
                      <DistributionListSelector
                        distributionList={distributionList}
                        onDistributionListChange={setDistributionList}
                        overHundredParticipants={eventData.overHundredParticipants}
                      />
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Footer
          saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Audience'
          canMoveNext={true}
        />
      </Item>
    </div>
  )
}
